import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

type TruckIconProps = {
    isRequestHandled: boolean;
};
const TruckIcon: FC<TruckIconProps> = ({ isRequestHandled }: TruckIconProps) => {
    const { t: translate } = useTranslation(['orders']);

    const iconColor = () => {
        return isRequestHandled ? 'success' : 'action';
    };

    const tooltipLabel = () => {
        return isRequestHandled ? translate('orders:TRANSPORT_SCHEDULED') : translate('orders:NO_TRANSPORT_SCHEDULED');
    };

    return (
        <Fragment>
            <Tooltip title={<span>{tooltipLabel()}</span>}>
                <LocalShippingIcon color={iconColor()} />
            </Tooltip>
        </Fragment>
    );
};

export default TruckIcon;
